import { Template1, Template2, Template3, Template4, Template5 } from '@/assets';

export const DATA_TEMPLATES = [
    {
        name: 'Stickies Packs',
        image: Template1
    },
    {
        name: 'Visual Table',
        image: Template5
    },
    {
        name: '2x2 Prioritization Method',
        image: Template2
    },
    {
        name: 'Mind Map',
        image: Template3
    },
    {
        name: 'Kanban Framework',
        image: Template4
    },
    {
        name: 'Quick Retrospective',
        image: Template1
    }
];
